export default __webpack_public_path__ + "static/cruiselines-vv-ship-6-6eb0ff0365ff3266c6a3f42cc8580ce9.jpg";